import axios from 'axios';
import { API_HOST } from '../helpers/constants';
import { headers } from '../utils';

const baseUrl = `${API_HOST}/lead-reasons`;

export const createLeadReason = (payload) => {
  return axios.post(`${baseUrl}`, payload, { headers });
};

export const deleteLeadReason = (id) => {
  return axios.delete(`${baseUrl}/${id}`, { headers });
};

export const updateLeadReason = (id, payload) => {
  return axios.put(`${baseUrl}/${id}`, payload, { headers });
};
